
import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DTypeFormFileField } from '@grupo-constant/next-dtype/form';
import { DTypeViewableCol } from '@grupo-constant/next-dtype/types';
import { DTypeFormFieldComponent } from '../../dtype-field.model';
import { FileUploaderComponent } from '../../../components/file-uploader/file-uploader.component';
import { LocalizePipe } from '../../../pipes/standalone/localize.pipe';

@Component({
    selector: 'image-field-component',
    templateUrl: './image-field.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FileUploaderComponent, LocalizePipe]
})
export class DtypeImageFieldComponent implements DTypeFormFieldComponent, OnInit {

    @Input() field: DTypeFormFileField;
    @Input() isUpdate: boolean;
    @Input() useSummaryView: boolean;
    displayedValue: string;

    constructor() { }

    ngOnInit() {
        const readonlyOnUpdate = (this.field.dTypeCol as DTypeViewableCol).readonlyOnUpdate;
        if (readonlyOnUpdate && this.isUpdate) {
            this.field.readonly = true;
        }

        this.displayedValue = this.field.control.value;
    }

}
